import { baseApi } from "common/redux/core/api.base";
import { KnowledgeAgentService } from "../../services/knowledge-agent.service";
import {
  AnalyseDocumentsRequest,
  ResumeSpecAuditRequest,
  StartPackageRequest,
  StartPackageResponse,
  TriggerSpecAuditRequest
} from "../../models/knowledge-agent.model";

const knowledgeAgentCommands = baseApi.injectEndpoints({
  endpoints: (build) => ({
    analyseDocuments: build.mutation<any, AnalyseDocumentsRequest>({
      queryFn: (request: AnalyseDocumentsRequest) => {
        return KnowledgeAgentService.analyseDocuments(request);
      },
      invalidatesTags: ["KNOWLEDGE_AGENT"]
    }),
    uploadReferenceStandard: build.mutation<any, File>({
      queryFn: (file: File) => {
        return KnowledgeAgentService.uploadReferenceStandard(file);
      },
      invalidatesTags: ["KNOWLEDGE_AGENT"]
    }),
    triggerSpecAuditSession: build.mutation<any, TriggerSpecAuditRequest>({
      queryFn: (request: TriggerSpecAuditRequest) => {
        return KnowledgeAgentService.triggerSpecAuditSession(request);
      }
    }),
    resumeSpecAuditSession: build.mutation<any, ResumeSpecAuditRequest>({
      queryFn: (request: ResumeSpecAuditRequest) => {
        return KnowledgeAgentService.resumeSpecAuditSession(request);
      }
    }),
    startPackage: build.mutation<StartPackageResponse, StartPackageRequest>({
      queryFn: (request: StartPackageRequest) => {
        return KnowledgeAgentService.startPackage(request);
      }
    })
  })
});

export const {
  useAnalyseDocumentsMutation,
  useUploadReferenceStandardMutation,
  useTriggerSpecAuditSessionMutation,
  useResumeSpecAuditSessionMutation,
  useStartPackageMutation
} = knowledgeAgentCommands;
